import I18n from 'I18n';
import FormattedMessage from 'I18n/components/FormattedMessage';
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'UICo... Remove this comment to see the full error message
import { maxDate } from 'UIComponents/core/SimpleDate';
import { Text } from 'foundations-components/components/Text';
import { LAST_THREE_MONTHS } from 'foundations-components/transitional/components/Dates';
import { now, toMoment, toMomentPortalTz } from 'foundations-components/transitional/utils/SimpleDate';
import { List, fromJS } from 'immutable';
import * as ChartTypes from 'reporting-data/constants/chartTypes';
import * as CompareTypes from 'reporting-data/constants/compareTypes';
import * as ConfigTypes from 'reporting-data/constants/configTypes';
import * as DataTypes from 'reporting-data/constants/dataTypes';
import { RANGE_TYPES as RangeTypes } from 'reporting-data/constants/dateRangeTypes';
import * as Frequency from 'reporting-data/constants/frequency';
import * as MetricTypes from 'reporting-data/constants/metricTypes';
import * as Operators from 'reporting-data/constants/operators';
import * as SortOrder from 'reporting-data/constants/sortOrder';
import fromJSOrdered from 'reporting-data/lib/fromJSOrdered';
import { colorAssignmentSets } from 'reporting-ui-components/constants/colorAssignmentSets';
import UICustomDataWellHeader from '../components/insights/articlePerformance/charts/UICustomDataWellHeader';
import SearchTermCellContent from '../components/insights/dashboard/SearchTermCellContent';
import * as SharedConstants from '../constants/SharedConstants';
import { SCREENS } from '../constants/TrackingConstants';
import * as ReportConstants from '../constants/insights/ReportConstants';
import TableConstants from '../constants/manage/TableConstants';
import { getShouldCallSCPEndpoints } from '../migration-handler/singleton/migrationHandler';
import { getReportRhumbConfig } from './reportRhumbConfig';
import { jsx as _jsx } from "react/jsx-runtime";
export const REPORTING_DATE_FORMAT = 'YYYY-MM-DD';
export function getDateFromSimpleDate(simpleDate) {
  return toMomentPortalTz(simpleDate).valueOf();
}
export function getAllTimeRange() {
  return {
    presetId: RangeTypes.CUSTOM,
    getValue: tz => ({
      startDate: SharedConstants.MIN_CUSTOM_DATE,
      endDate: now(tz)
    })
  };
}
export function getThisMonthTimeRange() {
  return LAST_THREE_MONTHS.getValue();
}
export function createReportingDateRange(dateRange = getAllTimeRange()) {
  const startDate = maxDate([SharedConstants.MIN_CUSTOM_DATE, dateRange.startDate]);
  return {
    rangeType: 'CUSTOM',
    startDate: toMoment(startDate).format(REPORTING_DATE_FORMAT),
    endDate: toMoment(dateRange.endDate).format(REPORTING_DATE_FORMAT)
  };
}
export function getArticleDataWellReport(analyticsPageId, dateRange, metrics, navMarkerName) {
  return fromJSOrdered({
    chartType: ChartTypes.DATA_WELL,
    config: {
      compare: CompareTypes.PRIOR_PERIOD,
      configType: ConfigTypes.AGGREGATION,
      dataType: DataTypes.ANALYTICS_KNOWLEDGE_ARTICLES,
      dimensions: List.of(),
      filters: {
        dateRange: {
          property: 'sessionDate',
          value: createReportingDateRange(dateRange)
        },
        custom: [{
          operator: Operators.EQ,
          property: 'filters',
          value: analyticsPageId
        }]
      },
      frequency: Frequency.DAY,
      metrics
    },
    displayParams: {
      render: {
        header: UICustomDataWellHeader.withProps()
      },
      rhumbConfig: getReportRhumbConfig(navMarkerName)
    }
  });
}
export function getArticleViewsReport(analyticsPageId, dateRange) {
  return fromJSOrdered({
    chartType: ChartTypes.AREA,
    config: {
      configType: ConfigTypes.TIME_SERIES,
      dataType: DataTypes.ANALYTICS_KNOWLEDGE_ARTICLES_SOURCES,
      dimensions: List.of('sessionDate', 'breakdown'),
      filters: {
        dateRange: {
          property: 'sessionDate',
          value: createReportingDateRange(dateRange)
        },
        custom: [{
          operator: Operators.EQ,
          property: 'pageId',
          value: analyticsPageId
        }, {
          operator: Operators.IN,
          property: 'filters',
          values: List.of('direct', 'organic', 'email', 'paid', 'social', 'paid-social', 'other', 'referrals', 'offline')
        }]
      },
      frequency: Frequency.DAY,
      metrics: [ReportConstants.VIEWS_METRIC],
      processors: List.of()
    },
    displayParams: {
      colors: {
        custom: colorAssignmentSets.get('sources')
      },
      rhumbConfig: getReportRhumbConfig('ARTICLE_VIEWS_OVER_TIME_REPORT_LOAD'),
      stacked: true
    }
  });
}
export function getArticleDetailsTableReport(dateRange, onSort, onRedirect, metrics, sort, maxFeedbackCount, knowledgeBaseId, parentKnowledgeBaseId) {
  return fromJSOrdered({
    chartType: ChartTypes.TABLE,
    config: {
      configType: ConfigTypes.AGGREGATION,
      dataType: DataTypes.KNOWLEDGE_ARTICLES,
      dimensions: List.of('id'),
      limit: TableConstants.NUM_ROWS_PER_PAGE,
      filters: {
        dateRange: {
          property: 'sessionDate',
          value: createReportingDateRange(dateRange)
        },
        custom: {
          knowledgeBaseId,
          knowledgeBaseIsLegacy: !getShouldCallSCPEndpoints(parentKnowledgeBaseId !== null && parentKnowledgeBaseId !== void 0 ? parentKnowledgeBaseId : knowledgeBaseId)
        }
      },
      metrics,
      processors: List.of(),
      sort
    },
    displayParams: {
      columns: {
        helpfulFeedback: {
          showAsBarChart: true,
          showAsBarChartOptions: {
            max: maxFeedbackCount
          }
        },
        unhelpfulFeedback: {
          showAsBarChart: true,
          showAsBarChartOptions: {
            max: maxFeedbackCount
          }
        }
      },
      onSort,
      resetOffsetOnSortChange: true,
      resetOffsetOnFilterChange: true,
      rhumbConfig: getReportRhumbConfig('ARTICLE_DETAILS_TABLE_LOAD')
    }
  });
}
export function getArticleSearchWithNoResultsReport(dateRange, knowledgeBaseId) {
  const {
    startDate,
    endDate
  } = createReportingDateRange(dateRange);
  return fromJS({
    chartType: ChartTypes.TABLE,
    config: {
      configType: ConfigTypes.AGGREGATION,
      dataType: DataTypes.UNIFIED_EVENTS,
      dimensions: ['{properties.hs_term}'],
      filters: {
        custom: [{
          operator: Operators.EQ,
          property: '{properties.hs_knowledge_base_id}',
          value: knowledgeBaseId
        }, {
          operator: Operators.EQ,
          property: 'total_search_results_found',
          value: 0
        }, {
          operator: Operators.GTE,
          property: 'total_searches',
          value: 1
        }],
        dateRange: {
          property: 'sessionDate',
          value: {
            endDate: endDate || I18n.moment.portalTz().format('YYYY-MM-DD'),
            rangeType: RangeTypes.CUSTOM,
            startDate: startDate || '2006-01-01'
          }
        }
      },
      limit: 5,
      metrics: [{
        property: 'total_searches'
      }],
      sort: [{
        order: SortOrder.DESC,
        property: 'total_searches'
      }],
      unifiedEvent: {
        reportType: 'e_knowledgebase_site_search_report',
        schemaVersion: 2
      }
    },
    displayParams: {
      columns: {
        '{properties.hs_term}': {
          render: args => /*#__PURE__*/_jsx(SearchTermCellContent, Object.assign({}, args, {
            usageTrackerObj: {
              action: 'tag-articles-search-no-results',
              screen: SCREENS.INSIGHTS
            }
          }))
        }
      }
    }
  });
}
export function getArticleTopSearchTermsReport(dateRange, getSearchTermUrl, knowledgeBaseId) {
  const {
    startDate,
    endDate
  } = createReportingDateRange(dateRange);
  return fromJS({
    chartType: ChartTypes.TABLE,
    config: {
      configType: ConfigTypes.AGGREGATION,
      dataType: DataTypes.UNIFIED_EVENTS,
      dimensions: ['{properties.hs_term}'],
      filters: {
        custom: [{
          operator: Operators.EQ,
          property: '{properties.hs_knowledge_base_id}',
          value: knowledgeBaseId
        }],
        dateRange: {
          property: 'sessionDate',
          value: {
            endDate: endDate || I18n.moment.portalTz().format('YYYY-MM-DD'),
            rangeType: RangeTypes.CUSTOM,
            startDate: startDate || '2006-01-01'
          }
        }
      },
      limit: 5,
      metrics: [{
        property: 'total_search_results_found'
      }, {
        property: 'total_searches'
      }, {
        property: 'total_search_conversions'
      }, {
        property: 'total_search_conversions_per_search'
      }],
      sort: [{
        order: SortOrder.DESC,
        property: 'total_search_results_found'
      }],
      unifiedEvent: {
        reportType: 'e_knowledgebase_site_search_report',
        schemaVersion: 2
      }
    },
    displayParams: {
      columns: {
        '{properties.hs_term}': {
          render: args => /*#__PURE__*/_jsx(SearchTermCellContent, Object.assign({}, args, {
            searchTermUrl: args.row.get('total_search_results_found') > 0 ? getSearchTermUrl(args.value) : undefined,
            usageTrackerObj: {
              action: 'tag-articles-most-searched-terms',
              screen: SCREENS.INSIGHTS
            }
          }))
        },
        total_search_results_found: {
          render: ResultsFoundColumn
        },
        total_search_conversions: {
          tooltipI18nKey: 'knowledgeContentUI.insights.dashboard.tooltips.totalResultClicks'
        },
        total_search_conversions_per_search: {
          tooltipI18nKey: 'knowledgeContentUI.insights.dashboard.tooltips.avgResultClicks'
        }
      }
    }
  });
}
export function getArticleTotalSearchesReport(dateRange, currentKnowledgeBaseId) {
  const {
    startDate,
    endDate
  } = createReportingDateRange(dateRange);
  const displayParams = {
    render: {
      header: () => null
    }
  };
  return fromJS({
    chartType: ChartTypes.DATA_WELL,
    config: {
      configType: ConfigTypes.AGGREGATION,
      dataType: DataTypes.UNIFIED_EVENTS,
      dimensions: ['{properties.hs_knowledge_base_id}'],
      filters: {
        custom: [{
          operator: Operators.EQ,
          property: '{properties.hs_knowledge_base_id}',
          value: currentKnowledgeBaseId
        }],
        dateRange: {
          property: 'sessionDate',
          value: {
            endDate: endDate || I18n.moment.portalTz().format('YYYY-MM-DD'),
            rangeType: RangeTypes.CUSTOM,
            startDate: startDate || '2006-01-01'
          }
        }
      },
      metrics: [{
        property: 'total_searches'
      }],
      unifiedEvent: {
        reportType: 'e_knowledgebase_site_search_report',
        schemaVersion: 2
      }
    },
    displayParams
  });
}

// #region Unified Events Search Report Configs
export function getTotalSearchesReportConfig(dateRange, currentKnowledgeBaseId, legacyKbId) {
  const {
    startDate,
    endDate
  } = createReportingDateRange(dateRange);
  const displayParams = {
    render: {
      header: () => null
    }
  };
  return fromJS({
    chartType: ChartTypes.DATA_WELL,
    config: {
      configType: ConfigTypes.AGGREGATION,
      dataType: DataTypes.UNIFIED_EVENTS_QL,
      filters: {
        dateRange: {
          property: 'date',
          value: {
            endDate: endDate || I18n.moment.portalTz().format('YYYY-MM-DD'),
            rangeType: RangeTypes.CUSTOM,
            startDate: startDate || '2006-01-01'
          }
        },
        filterGroups: [{
          filters: [{
            operator: Operators.IN,
            property: 'hs_knowledge_base_id',
            values: legacyKbId ? [currentKnowledgeBaseId, legacyKbId] : [currentKnowledgeBaseId]
          }]
        }]
      },
      metrics: [{
        metricTypes: [MetricTypes.COUNT],
        property: 'hs_knowledge_base_id'
      }],
      unifiedEventTypeName: 'e_site_searched'
    },
    displayParams
  });
}
export function getSearchWithNoResultsReportConfig(dateRange, currentKnowledgeBaseId, legacyKbId) {
  const {
    startDate,
    endDate
  } = createReportingDateRange(dateRange);
  return fromJS({
    chartType: ChartTypes.TABLE,
    config: {
      configType: ConfigTypes.AGGREGATION,
      dataType: DataTypes.UNIFIED_EVENTS_QL,
      dimensions: ['hs_term'],
      filters: {
        dateRange: {
          property: 'date',
          value: {
            endDate: endDate || I18n.moment.portalTz().format('YYYY-MM-DD'),
            rangeType: RangeTypes.CUSTOM,
            startDate: startDate || '2006-01-01'
          }
        },
        filterGroups: [{
          filters: [{
            operator: Operators.IN,
            property: 'hs_knowledge_base_id',
            values: legacyKbId ? [currentKnowledgeBaseId, legacyKbId] : [currentKnowledgeBaseId]
          }, {
            operator: Operators.EQ,
            property: 'hs_results',
            value: 0
          }]
        }]
      },
      limit: 5,
      metrics: [{
        metricTypes: [MetricTypes.SUM],
        property: 'count'
      }],
      sort: [{
        order: SortOrder.DESC,
        property: 'count'
      }],
      unifiedEventTypeName: 'e_site_searched'
    },
    visualization: {
      columns: [{
        field: 'hs_term',
        renderCell: args => /*#__PURE__*/_jsx(SearchTermCellContent, Object.assign({}, args, {
          usageTrackerObj: {
            action: 'tag-articles-search-no-results',
            screen: SCREENS.INSIGHTS
          }
        }))
      }, {
        field: `${MetricTypes.SUM}|count`,
        label: I18n.text('knowledgeContentUI.insights.dashboard.articleTotalSearches')
      }],
      type: ChartTypes.TABLE
    },
    name: 'Search Terms With No Results'
  });
}
export function getTopSearchTermsReportConfig(dateRange, getSearchTermUrl, currentKnowledgeBaseId, legacyKbId) {
  const {
    startDate,
    endDate
  } = createReportingDateRange(dateRange);
  return fromJS({
    chartType: ChartTypes.TABLE,
    config: {
      configType: ConfigTypes.AGGREGATION,
      dataType: DataTypes.UNIFIED_EVENTS_QL,
      dimensions: ['hs_term'],
      filters: {
        dateRange: {
          property: 'date',
          value: {
            endDate: endDate || I18n.moment.portalTz().format('YYYY-MM-DD'),
            rangeType: RangeTypes.CUSTOM,
            startDate: startDate || '2006-01-01'
          }
        },
        filterGroups: [{
          filters: [{
            operator: Operators.IN,
            property: 'hs_knowledge_base_id',
            values: legacyKbId ? [currentKnowledgeBaseId, legacyKbId] : [currentKnowledgeBaseId]
          }]
        }]
      },
      limit: 5,
      metrics: [{
        metricTypes: [MetricTypes.SUM],
        property: 'hs_results'
      }, {
        metricTypes: [MetricTypes.SUM],
        property: 'count'
      }, {
        metricTypes: [MetricTypes.SUM],
        property: 'raas_xd_click_rate'
      }],
      sort: [{
        order: SortOrder.DESC,
        property: 'hs_results'
      }],
      unifiedEventTypeName: 'e_site_searched'
    },
    name: 'Most Searched Terms',
    reportConfigs: {
      secondary: {
        configType: ConfigTypes.AGGREGATION,
        dataType: DataTypes.UNIFIED_EVENTS_QL,
        dimensions: ['hs_term'],
        filters: {
          dateRange: {
            property: 'date',
            value: {
              endDate: endDate || I18n.moment.portalTz().format('YYYY-MM-DD'),
              rangeType: RangeTypes.CUSTOM,
              startDate: startDate || '2006-01-01'
            }
          },
          filterGroups: [{
            filters: [{
              operator: Operators.IN,
              property: 'hs_knowledge_base_id',
              values: legacyKbId ? [currentKnowledgeBaseId, legacyKbId] : [currentKnowledgeBaseId]
            }]
          }]
        },
        limit: 5,
        metrics: [{
          metricTypes: [MetricTypes.SUM],
          property: 'count'
        }],
        sort: [],
        unifiedEventTypeName: 'e_site_search_converted'
      }
    },
    visualization: {
      columns: [{
        field: 'hs_term',
        dataset: 'primary',
        renderCell: props => /*#__PURE__*/_jsx(SearchTermCellContent, Object.assign({}, props, {
          searchTermUrl: props.row.get(`${MetricTypes.SUM}|hs_results`) > 0 ? getSearchTermUrl(props.value) : undefined,
          usageTrackerObj: {
            action: 'tag-articles-most-searched-terms',
            screen: SCREENS.INSIGHTS
          }
        }))
      }, {
        dataset: 'primary',
        field: `${MetricTypes.SUM}|hs_results`,
        label: I18n.text('knowledgeContentUI.insights.dashboard.reportColumnLabels.resultsFound'),
        renderCell: ResultsFoundColumn
      }, {
        dataset: 'primary',
        field: `${MetricTypes.SUM}|count`,
        label: I18n.text('knowledgeContentUI.insights.dashboard.articleTotalSearches')
      }, {
        dataset: 'secondary',
        field: `${MetricTypes.SUM}|count`,
        label: I18n.text('knowledgeContentUI.insights.dashboard.reportColumnLabels.totalResultClicks'),
        tooltipI18nKey: 'knowledgeContentUI.insights.dashboard.tooltips.totalResultClicks'
      }, {
        dataset: 'primary',
        field: `${MetricTypes.SUM}|raas_xd_click_rate`,
        label: I18n.text('knowledgeContentUI.insights.dashboard.reportColumnLabels.avgResultClicks'),
        tooltipI18nKey: 'knowledgeContentUI.insights.dashboard.tooltips.avgResultClicks'
      }],
      type: ChartTypes.TABLE
    }
  });
}
// #endregion

function ResultsFoundColumn({
  field,
  row
}) {
  return /*#__PURE__*/_jsx("td", {
    children: /*#__PURE__*/_jsx(Text, {
      textAlign: "left",
      children: row.get(field) > 0 ? /*#__PURE__*/_jsx(FormattedMessage, {
        message: "knowledgeContentUI.insights.dashboard.rowValues.trueValue"
      }) : /*#__PURE__*/_jsx(FormattedMessage, {
        message: "knowledgeContentUI.insights.dashboard.rowValues.falseValue"
      })
    })
  });
}